import React, { useRef, useState} from "react";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import PaginationControl  from "../componentesSecundarios/PaginationControl";
export default function Piepagina(){
    const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
    const _totalBusqueda= useStoreGlobal(useShallow((state) => state._totalBusqueda));
    const _updatePage= useStoreGlobal(useShallow((state) => state._updatePage));
    
    const [selectedFin, setSelectedFin] = useState(10);
    const numeroFinal = useRef(null);
    let texto="Resultados por página:";
    let pagina="Página:";
    if (window.location.href.indexOf("en.") > -1) {
        texto = "Results per page:";
        pagina = "Page:";
    }
    const handleSelect = (event) => {
        event.preventDefault();
        const fin = event.target.value;
        setSelectedFin(fin);
        _updateFiltros({paginaFin:fin});
        _updatePage({page: 1});
        $("#search").trigger("click");
    }
    let totalDatos = 0;
    if(Object.keys(_totalBusqueda).length > 0){
        totalDatos =_totalBusqueda.totalDatos;
    }
    return(
        <>
            {
                totalDatos > 0? (
                    <div className="col-xs-12 text-center" id="bottom-navigation">
                        <div className="col-xs-12" id="linea-separadora"><hr/>
                        </div>
                        <div className="row col-lg-12" id="rowprin">
                                <div className="col-lg-9"  id="paginacion">
                                    <span id="pagina">{pagina} </span>
                                    <PaginationControl />
                                </div>
                                <div className="col-md-12 col-lg-3" id="resupaginacion">
                                    <label id="resuxpagina" htmlFor="info" style={{float:"left", marginTop:"10px", paddingRight:"5px"}}>{texto}</label>
                                        <select className="form-select" value={selectedFin} ref={numeroFinal} onChange={(event) => handleSelect(event)} id="info" name="select"  style={{width:"28%"}} >
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                </div>
                        </div>
                    </div>
                ): ""
            }
        </>     
    )
}

